import { SyntheticEvent } from "react";
import Image from "@Components/Image";
import { Button } from "@Components/ui";
import { INearestPickupLocation } from "@Types/ZipCodePopUps";
import classes from "../ZipCodePopUp.module.scss";

interface IWeDeliverLayoutProps {
  deliverTitle: string;
  deliverMessage: string;
  deliverButtonLabel: string;
  deliverLocationIcon: {
    url: string;
    title: string;
    width: number;
    height: number;
  };
  deliverChangePostalCodeText: string;
  zipcode: string;
  handleToggle: (e: SyntheticEvent<Element, Event>) => void;
  switchLayout: (e: SyntheticEvent<Element, Event>) => void;
  nearestPickupLocation: INearestPickupLocation;
  isPickupAvailable: boolean;
  onlyDeliveryAvailableTitle: string;
}
export default function WeDeliverLayout({
  deliverTitle,
  deliverButtonLabel,
  deliverLocationIcon,
  deliverChangePostalCodeText,
  zipcode,
  handleToggle,
  switchLayout,
  nearestPickupLocation,
  isPickupAvailable,
  onlyDeliveryAvailableTitle,
}: IWeDeliverLayoutProps) {
  return (
    <div
      className={`${classes["trade-area__content"]}`}
      data-testid="layout--we-deliver"
    >
      <h2 className={classes["trade-area__title"]}>{`${
        isPickupAvailable ? deliverTitle : onlyDeliveryAvailableTitle
      } ${zipcode}`}</h2>

      {/* 
      NOTE:https://wild-fork-canada.atlassian.net/browse/CE-1727
      {isPickupAvailable && (
        <p className={classes["trade-area__copy"]}>{deliverMessage}</p>
      )} */}
      {nearestPickupLocation && (
        <div
          className={classes["trade-area__no_nearest_pickup_location"]}
        ></div>
      )}
      <Button
        type="submit"
        className="trade-area__action action action--primary"
        onClick={handleToggle}
      >
        {deliverButtonLabel}
      </Button>
      <div className={classes["trade-area__change-location-wrapper"]}>
        <i className={classes["trade-area__change-location-pin"]}>
          <Image
            src={`${deliverLocationIcon?.url}?w=30&h=30`}
            width={30}
            height={30}
            alt="icon_delivery"
            data-testid="icon_delivery"
          />
        </i>
        <Button
          type="button"
          data-testid="button-switch-layout"
          className={classes["trade-area__change-location-button"]}
          onClick={switchLayout}
        >
          {deliverChangePostalCodeText}
        </Button>
      </div>
    </div>
  );
}
